const Title = ({ marca, title }) => {
  return <p className={`title ${marca}`}>{title}</p>;
};

export default Title;
